class Matomo {
  /**
   * @param {MatomoEvent} event
   */
  static trackEvent(event) {
    if (!window._paq) {
      console.error(
        "window._paq is missing, matomo is not initialized properly."
      );
      return;
    }

    window._paq.push(event);
  }
}

export default Matomo;
